import { Component } from '@angular/core';

@Component({
  selector: 'opac-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent {}
